// libs
import cx from 'classnames';
import React, { memo, useEffect, useMemo, useState } from 'react';
// widgets
import DropdownOption from '../Option';
import Shimmer from '@/widgets/Shimmer';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
import { Checkbox } from '@swiggy-private/dls-web-core/dist/components/Checkbox';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './Content.module.scss';
function DropDownContent({ options, selectAllLabel, showLoader, errorMessage, searchText, renderFunction, updateOptions, closeMenu, onChange, className, }) {
    const [allSelected, setAllSelected] = useState(false);
    useEffect(() => {
        const allOptionSelected = options.every((option) => option.selected);
        setAllSelected(allOptionSelected);
    }, [options]);
    const selectedOptions = useMemo(() => {
        return options.filter((option) => option.selected);
    }, [options]);
    const onOptionSelect = (option) => {
        const updatedOptions = [...options];
        const index = updatedOptions.findIndex((i) => i.id === option.id);
        updatedOptions[index].selected = !updatedOptions[index].selected;
        updateOptions(updatedOptions);
        onChange(updatedOptions);
    };
    const handleAllSelect = (isChecked) => {
        const updatedOptions = [...options];
        for (const option of updatedOptions) {
            option.selected = isChecked;
        }
        updateOptions(updatedOptions);
        onChange(updatedOptions);
    };
    const onSelectAllClick = () => {
        const isChecked = !allSelected;
        setAllSelected(isChecked);
        handleAllSelect(isChecked);
    };
    const onAddSelectedClick = () => {
        closeMenu();
    };
    const renderLoader = () => {
        return (React.createElement(React.Fragment, null, Array.from({ length: 5 }).map((_, index) => {
            return (React.createElement("div", { className: styles.containerLoaderItem, key: index },
                React.createElement(Shimmer, null)));
        })));
    };
    const renderErrorMessage = () => {
        return (React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.negative }, errorMessage));
    };
    const renderOptions = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.selectAll, onClick: onSelectAllClick },
                React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Med_Emphasis }, `Add all ${options.length} ${selectAllLabel !== null && selectAllLabel !== void 0 ? selectAllLabel : 'options'}`),
                React.createElement(Checkbox, { label: "", orientation: "rtl", id: "cb1", checked: allSelected })),
            React.createElement("div", { className: cx(styles.options, className === null || className === void 0 ? void 0 : className.options) }, options.map((option, index) => {
                return (React.createElement(DropdownOption, { key: option.id, option: option, index: index, onOptionSelect: onOptionSelect, renderFunction: renderFunction }));
            })),
            React.createElement("div", { className: styles.footer },
                React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Med_Emphasis }, selectedOptions.length
                    ? `${selectedOptions.length} selected`
                    : ''),
                React.createElement(TextButton, { onClick: onAddSelectedClick, buttonSize: "small", color: DlsColorTokens.primary, className: styles.footerCta }, "Done"))));
    };
    const renderEmpty = () => {
        return (React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Low_Emphasis }, searchText ? 'No results found' : 'Enter something to search'));
    };
    const renderContent = () => {
        if (showLoader) {
            return renderLoader();
        }
        if (errorMessage) {
            return renderErrorMessage();
        }
        if (!options.length) {
            return renderEmpty();
        }
        return renderOptions();
    };
    const containerClassName = cx(styles.container, {
        [styles.containerError]: !!errorMessage && !showLoader,
        [styles.containerLoader]: showLoader,
        [styles.containerEmpty]: !options.length && !showLoader && !errorMessage,
    });
    return React.createElement("div", { className: containerClassName }, renderContent());
}
export default memo(DropDownContent);
